import React from 'react';

import Icon from '../Icon/Icon';

const BigPlusIcon = (props) => {
    return (
        <Icon width='40' height='40' {...props}>
            <path d='M33.2241 20.0026H6.78442' stroke='#34303D' strokeWidth='2.5' strokeLinecap='round' />
            <path d='M20.0042 6.78106V33.2207' stroke='#34303D' strokeWidth='2.5' strokeLinecap='round' />
        </Icon>
    );
};

export default BigPlusIcon;
